import { injectable } from "tsyringe";
import { BaseApi } from "../apiConfig/BaseApi";
import { IReportRepository } from "$src/domain/reporting/IReportRepository";
import { ProjectReport } from "$src/domain/reporting/ReportTypes";
import { BlobResult } from "../network/BlobResult";

@injectable()
export class ReportRepositoryApi extends BaseApi implements IReportRepository {
    
    getProjectById(groupStoreId: number, projectId: number): Promise<ProjectReport[]> {
        throw new Error("Method not implemented.");
    }
    generate(groupStoreId: number, projectId: number, reportId: number): Promise<BlobResult> {
        throw new Error("Method not implemented.");
    }
    
}